"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CookieBanner = void 0;

var react_1 = __importStar(require("react"));

var react_localization_1 = __importDefault(require("react-localization"));

var elements_1 = require("../../elements");

var utils_1 = require("../../utils");

var json = __importStar(require("./localization.json")); // https://www.cookiepolicygenerator.com/
// https://eigene-homepage.net/cookie-hinweis
// https://www.termsfeed.com/cookie-consent/


var CookieBanner = function CookieBanner(_a) {
  var children = _a.children,
      theme = _a.theme,
      language = _a.language,
      _b = _a.isCookieSet,
      isCookieSet = _b === void 0 ? false : _b,
      title = _a.title,
      text = _a.text,
      buttonAcceptType = _a.buttonAcceptType,
      buttonDeclineType = _a.buttonDeclineType,
      cookieKey = _a.cookieKey;
  var localizedStrings = new react_localization_1["default"](json);
  localizedStrings.setLanguage(language);

  var _c = (0, react_1.useState)(isCookieSet),
      isCookieSetState = _c[0],
      setIsCookieSetState = _c[1];

  var style = "z-0 bg-teal-100 bg-opacity-25 rounded-lg m-4 p-4 text-center " + (theme ? theme.body.textColor : "text-gray-800");
  var key = cookieKey ? cookieKey : utils_1.COOKIE_KEY;

  var onAcceptClicked = function onAcceptClicked() {
    var cookie = JSON.stringify({
      analytics: true
    });
    (0, utils_1.setStorageItem)(key, cookie);
    setIsCookieSetState(true);
  };

  var onDeclineClicked = function onDeclineClicked() {
    var cookie = JSON.stringify({
      analytics: false
    });
    (0, utils_1.setStorageItem)(key, cookie);
    setIsCookieSetState(true);
  };

  var bannerTitle = title ? title : localizedStrings.cookieBanner.title;
  var bannerText = text ? text : localizedStrings.cookieBanner.text;
  var buttonAcceptStyle = buttonAcceptType ? buttonAcceptType : elements_1.ButtonType.primary;
  var buttonDeclineStyle = buttonDeclineType ? buttonDeclineType : elements_1.ButtonType.tertiary;
  return react_1["default"].createElement(react_1["default"].Fragment, null, !isCookieSetState && react_1["default"].createElement("div", {
    className: style
  }, react_1["default"].createElement(elements_1.TitleAbstract, {
    theme: theme,
    marginBottom: true
  }, bannerTitle), react_1["default"].createElement(elements_1.Comment, {
    theme: theme,
    marginBottom: true
  }, bannerText), react_1["default"].createElement("div", {
    className: "flex flex-row justify-center"
  }, react_1["default"].createElement("span", {
    className: "mr-1"
  }, react_1["default"].createElement(elements_1.ButtonRegular, {
    onClick: onAcceptClicked,
    text: "Accept",
    size: elements_1.ButtonSize.small,
    type: buttonAcceptStyle
  })), react_1["default"].createElement("span", {
    className: "ml-1"
  }, react_1["default"].createElement(elements_1.ButtonRegular, {
    onClick: onDeclineClicked,
    text: "Decline",
    size: elements_1.ButtonSize.small,
    type: buttonDeclineStyle
  })))), children);
};

exports.CookieBanner = CookieBanner;